module.exports = __webpack_public_path__ + "img/icon-phone.2328aeae.svg";